import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Doubts } from "../components/Doubts";
import { Formula } from "../components/Formula";
import { Journey } from "../components/Journey";
import { FlowKus } from "../components/FlowKus";
import { Program } from "../components/Program";
import { About } from "../components/About";
import { Vision } from "../components/Vision";
import { NextStep } from "../components/NextStep";
import { Testimonials } from "../components/Testimonials";
import { Faq } from "../components/Faq";
import { scrollToSection } from "../utils/scroll";
export function Home() {
  const {
    hash,
    key
  } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    // Wait one frame so the page (and a closing menu) has laid out before measuring.
    const raf = requestAnimationFrame(() => scrollToSection(hash.slice(1)));
    return () => cancelAnimationFrame(raf);
  }, [hash, key]);
  return <>
      <Hero data-id="element-332" data-mp="30w0582vzto53" />
      <Doubts data-id="element-333" data-mp="30uoz3wf2s4at" />
      <Formula data-id="element-334" data-mp="2vxoulpxvj9lt" />
      <Journey data-id="element-335" data-mp="2vx6rqagphx4x" />
      <FlowKus data-id="element-336" data-mp="2vyq8012d486p" />
      <Program data-id="element-337" data-mp="2vyzvnhzxq398" />
      <About data-id="element-338" data-mp="2vyhr7y34ciq8" />
      <Testimonials data-id="element-339" data-mp="2vvvnk9jcmnda" />
      <Vision data-id="element-340" data-mp="2qybyeel44q6k" />
      <Faq data-id="element-341" data-mp="2qxu61t1kmw3x" />
      <NextStep data-id="element-342" data-mp="2qxkfa38pckx6" />
    </>;
}